var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',{staticClass:"acts-list",attrs:{"gutter":16,"type":"flex","align":"top"}},_vm._l((_vm.acts),function(act){return _c('i-col',{key:act.id,attrs:{"span":"24"}},[_c('acts-item',{attrs:{"act":act,"all":_vm.all},on:{"open-act":_vm.openAct}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }